import type { ReactNode } from "react";

export function Shell({ sidebar, topbar, children }: {
  sidebar: ReactNode; topbar?: ReactNode; children: ReactNode;
}) {
  return (
    <div className="shell">
      {sidebar}
      <div className="shell-main">
        {topbar}
        <main className="page">{children}</main>
      </div>
    </div>
  );
}

export function Sidebar({ brand, children }: { brand?: ReactNode; children: ReactNode }) {
  return (
    <nav className="sidebar" aria-label="Main">
      {brand && <div className="sidebar-brand">{brand}</div>}
      {children}
    </nav>
  );
}

export function SidebarGroup({ label }: { label: string }) {
  return <div className="sidebar-group">{label}</div>;
}

export function NavItem({ icon, label, badge, active, onClick, href }: {
  icon?: ReactNode; label: ReactNode; badge?: ReactNode;
  active?: boolean; onClick?: () => void; href?: string;
}) {
  const inner = (
    <>
      {icon}
      <span>{label}</span>
      {badge !== undefined && <span className="nav-badge">{badge}</span>}
    </>
  );
  // aria-current must be absent (not false) when inactive, or every item reads as current.
  const current = active ? { "aria-current": "page" as const } : {};
  return href
    ? <a className="nav-item" href={href} onClick={onClick} {...current}>{inner}</a>
    : <button className="nav-item" onClick={onClick} {...current}>{inner}</button>;
}

export function Topbar({ left, right }: { left?: ReactNode; right?: ReactNode }) {
  return (
    <header className="topbar">
      <div className="row-tight">{left}</div>
      <div className="row-tight">{right}</div>
    </header>
  );
}
